import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addSelectedTrim, fetchTrimDetailsAsync, selectSelectedTrims } from '../store/global/reducer';
import { MAX_TRIMS_COMPARE } from '../../../../constants';

const useSetCompareBtn = () => {
  const dispatch = useDispatch();
  const [hasCompareBtn, setHasCompareBtn] = useState(false);
  const selectedTrims = useSelector(selectSelectedTrims);

  const getActiveColorCode = (el) => {
    const canColorInputSelector = ['.js-color-radio'];
    const colorInputs = el?.querySelectorAll(canColorInputSelector.join(','));
    if (colorInputs) {
      let selectedValue;
      colorInputs.forEach((input) => {
        if (input.checked) {
          selectedValue = input.getAttribute('data-color-code');
        }
      });
      return selectedValue;
    }
    return '';
  };

  const getTrimCardElement = (el) => {
    const canTrimCardSelector = ['.js-model-item'];
    const allTrimCardElements = document.querySelectorAll(canTrimCardSelector.join(','));
    const trimCardElement = Array.from(allTrimCardElements).find((trimCard) => trimCard.contains(el));
    return trimCardElement || null;
  };

  const setCompareBtn = useCallback(() => {
    const compareBtns = document.querySelectorAll('.js-btn-compare');
    setHasCompareBtn(compareBtns.length > 0);
    compareBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const modelId = btn.getAttribute('data-model-id');
        const trimCardElement = getTrimCardElement(btn);
        const colorId = getActiveColorCode(trimCardElement);
        dispatch(addSelectedTrim({ modelId, colorCode: colorId, loading: true }));
        dispatch(fetchTrimDetailsAsync({ trimId: modelId, colorId }));
      });
    });
  }, [dispatch]);

  useEffect(() => {
    const handleDOMReady = () => {
      setCompareBtn();
      // Clean up event listener
      window.removeEventListener('load', handleDOMReady);
    };

    if (document.readyState === 'complete') {
      setCompareBtn();
    } else {
      window.addEventListener('load', handleDOMReady);
    }

    // Clean up function
    return () => {
      window.removeEventListener('load', handleDOMReady);
    };
  }, [setCompareBtn]);

  useEffect(() => {
    if (selectedTrims.length >= MAX_TRIMS_COMPARE) {
      const compareBtns = document.querySelectorAll('.js-btn-compare');
      compareBtns.forEach((btn) => {
        btn.classList.add('btn-disabled');
      });
    } else {
      const compareBtns = document.querySelectorAll('.js-btn-compare');
      compareBtns.forEach((btn) => {
        btn.classList.remove('btn-disabled');
      });
    }

    if (selectedTrims.length) {
      const compareBtns = document.querySelectorAll('.js-btn-compare');
      compareBtns.forEach((btn) => {
        if (selectedTrims.some((trim) => trim.modelId === btn.getAttribute('data-model-id'))) {
          btn.classList.add('btn-disabled');
        }
      });
    }
  }, [selectedTrims, dispatch]);

  return { hasCompareBtn };
};

export default useSetCompareBtn;
